module.exports = __webpack_public_path__ + "static/media/ticket-uber-4.b860ae8d.gif";